import IframeResizer from '@rio-cloud/iframe-resizer';
import type { JSX } from 'react';
import { connect } from 'react-redux';

import type { State } from '../../reducers';
import type { NonFunctionProperties } from '../../utils/util';
import { getSelectedVehicles } from '../tree/redux/tree.redux';

interface UpsellingBuyButtonProps {
    selectedAssetId: string | undefined;
}

const marketplaceUrlForTimed = 'https://upselling.marketplace.rio.cloud/?productId=rio-sku00000027&level=15';

const UpsellingBuyButton = (props: UpsellingBuyButtonProps): JSX.Element => {
    const { selectedAssetId } = props;

    if (!selectedAssetId) {
        return <></>;
    }

    return (
        <div>
            <IframeResizer
                src={`${marketplaceUrlForTimed}&resourceId=${selectedAssetId}`}
                title={'UpsellingView'}
                height={0}
            />
        </div>
    );
};

const mapStateToProps = (state: State): NonFunctionProperties<UpsellingBuyButtonProps> => {
    const selectedVehicles = getSelectedVehicles(state);
    return {
        selectedAssetId: selectedVehicles.length === 1 ? selectedVehicles[0] : undefined,
    };
};

export const UpsellingBuyButtonContainer = connect(mapStateToProps)(UpsellingBuyButton);
